module.exports = __webpack_public_path__ + "static/img/1_1_4_1.81e9edc3.jpg";